import React, { Component } from 'react';

class SaveProductWastedError extends Component {
  render() {
    return (
      <div
        className="modal fade theme-modal" id="saveProductWastedError"
        tabIndex="-1" aria-labelledby="saveProductWastedErrorModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title">Save Products</h5>
              <p>An inventory type is required before marking a product as wasted.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaveProductWastedError;
